import type { StoxlyClient } from '@stoxly/api-client';

export function createWebhookMutations(client: StoxlyClient) {
  return {
    handleNews: {
      mutationFn: () => client.newsWebhooksHandle(undefined),
    },
    handleSnaptrade: {
      mutationFn: ({ signature }: { signature: string }) =>
        client.snaptradeWebhookHandleWebhook(undefined, { headers: { signature } }),
    },
    handleBilling: {
      mutationFn: () => client.billingHandleWebhook(undefined),
    },
  };
}
